import { Component } from '@angular/core';
import { DirectSessionLogicService } from '../../../shared/direct-session-logic.service';


@Component({
  selector: 'faq-text',
  template: `
  <div class="modal" tabindex="-1" id="dialog-faq">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">FAQ</h4>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div [innerHTML]="agilityContentModelFaq"></div>              
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
  </div>
  `,
  styleUrl: './faq.component.scss',
  standalone: true,
  host: {'class': 'faq-text'},
})
export class FaqComponent {

  constructor(
    private readonly directSessionLogic: DirectSessionLogicService
  ) {
    
  }

  get agilityContentModelFaq(): string {
    return this.directSessionLogic.agilityObjectsSignalValue.fAQBody;
  }

}
